var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconoVideos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 90 90",
    style: {
      enableBackground: "new 0 0 90 90"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:url(#SVGID_1_);stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 3.6614,
    y1: 44.8022,
    x2: 86.3166,
    y2: 44.8022
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7284FD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#94DCF4"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M80.48,58.56H9.68c-2.22,0-4.03-1.8-4.03-4.03V16.47c0-2.22,1.8-4.03,4.03-4.03h70.8c2.22,0,4.03,1.8,4.03,4.03 v38.07C84.51,56.76,82.71,58.56,80.48,58.56z M37.27,23.97v22.32L52.52,35.5L37.27,23.97z M38.39,71.18L4.91,71.24 M50.29,71.4 c0,3.18-2.58,5.77-5.77,5.77s-5.77-2.58-5.77-5.77s2.58-5.77,5.77-5.77S50.29,68.21,50.29,71.4z M51.59,71.24l33.48-0.05"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoVideos);
export default __webpack_public_path__ + "static/media/icono_videos.6d275c8c9f0ba62b95c199e198cb6474.svg";
export { ForwardRef as ReactComponent };